<template>
  <div>
    <div class="region-selects" v-if="type == 1">
      <el-select v-model="country" placeholder="请选择" @change="choseCountry" :disabled="disabled" :style="selectStyle">
        <el-option v-for="item in countries" :key="item.code" :label="item.name" :value="item.code">
        </el-option>
      </el-select>
      <el-select v-model="province" placeholder="选择省份" @change="choseProvince" :disabled="canSelect || disabled" :style="selectStyle">
        <el-option v-for="item in provinces" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="city" placeholder="选择市" @change="choseCity" :disabled="canSelect || disabled" :style="selectStyle">
        <el-option v-for="item in citys" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="area" placeholder="选择县/区" @change="choseArea" :disabled="canSelect || disabled" :style="selectStyle">
        <el-option v-for="item in areas" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="region-selects width270 height40" v-if="type == 2">
      <el-select v-model="province" placeholder="选择省份" @change="choseProvince" :style="selectStyle">
        <el-option v-for="item in provinces" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="city" placeholder="选择市" @change="choseCity" :style="selectStyle">
        <el-option v-for="item in citys" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="region-selects" v-if="type == 3">
      <el-select v-model="province" placeholder="选择省份" @change="choseProvince" :style="selectStyle">
        <el-option v-for="item in provinces" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="city" placeholder="选择市" @change="choseCity" :style="selectStyle" :disabled="canSelect || disabled">
        <el-option v-for="item in citys" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="area" placeholder="选择县/区" @change="choseArea" :style="selectStyle" :disabled="canSelect || disabled">
        <el-option v-for="item in areas" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { regions } from './regions';
export default {
  name: "regionSelect",
  props: {
    regionArr: {
      type: Array,
      default: () => []
    },
    disabled:{
        type:Boolean,
        default:false
    },
    type:{
        type:Number,
        default:1
    },
    selectStyle:{
      type:String,
      default:''
    }
  },
  data(){
    return{
      countries:regions.countries,
      country:'',
      province: "",
      city: "",
      area: "",
      provinces: [],
      citys: [],
      areas: [],
      canSelect:true,
      citysTemp:[], //城市下拉模板数据
      areasTemp:[]  //地区下拉模板数据
    }
  },
  created() {
    [this.country,this.province,this.city,this.area] = this.regionArr;
    if(this.type == 2 || this.type == 3){
      this.country = 'CN'
    }
　　this.getCityData();//必须省市区赋值这段代码下面
    if(this.country === 'CN'){
        this.canSelect = false;
    }else if(this.country === 'USA' || !this.province){
        this.province = '';
        this.city = '';
        this.area = '';
    }
    if(this.province == '810000' || this.province == '820000'){
      this.canSelect = true;
    }
　},
  methods: {
    getCityData(){
        this.provinces = [];
        this.citys = [];
        this.areas = [];
        var data = regions.data;
        // 省市区数据分类
        for (var item in data) {
            if (item.match(/0000$/)) {//省
                this.provinces.push({id: item, value: data[item], children: []})
            } else if (item.match(/00$/)) {//市
                //this.citys.push({id: item, value: data[item], children: []})
                this.citysTemp.push({id: item, value: data[item], children: []})
            } else {//区
                //this.areas.push({id: item, value: data[item]})
                this.areasTemp.push({id: item, value: data[item]})
            }
        }
        // 分类市级
        for (var index in this.provinces) {
          for (var index1 in this.citysTemp) {
            if (this.provinces[index].id.slice(0, 2) === this.citysTemp[index1].id.slice(0, 2)) {
              this.provinces[index].children.push(this.citysTemp[index1])
            }
          }
        }
        //编辑情况下，根据省份是否选择判断是编辑，获取该省下的城市
        if(this.province){
          for (var index in this.provinces) {
            if(this.province == this.provinces[index].id){
              this.citys = this.provinces[index].children;
            }
          }
        }
        // 分类区级
        for(var item1 in this.citysTemp) {
            for(var item2 in this.areasTemp) {
                if (this.areasTemp[item2].id.slice(0, 4) === this.citysTemp[item1].id.slice(0, 4)) {
                    this.citysTemp[item1].children.push(this.areasTemp[item2])
                }
            }
        }
        //编辑情况下，根据省份是否选择判断是编辑，获取该省该市下的地区
        if(this.province){
          for(var index in this.citysTemp) {
              if(this.city == this.citysTemp[index].id){
                this.areas = this.citysTemp[index].children;
              }
          }
        }
    },
    choseCountry(e){
        if(e=="USA"){
            this.canSelect = true;
            this.province = '';
            this.city = '';
            this.area = '';
        }else{
            this.canSelect = false;
            this.citys = [];
            this.areas = [];
        }
        this.country = e;
        this.emitData();
    },
    choseProvince(e){
      if(e == '810000' || e == '820000'){
        this.canSelect = true;
      }else{
        this.canSelect = false;
      }
        for (var index in this.provinces) {
            if (e === this.provinces[index].id) {
                this.citys = this.provinces[index].children;
                this.city = this.provinces[index].children[0] && this.provinces[index].children[0].id;
                this.areas = this.provinces[index].children[0] && this.provinces[index].children[0].children;
                this.area = this.provinces[index].children[0] && this.provinces[index].children[0].children[0].id;
            }
        }
        this.emitData();
    },
    choseCity(e){
        for (var index in this.citys) {
            if (e === this.citys[index].id) {
                this.areas = this.citys[index].children;
                this.area = this.citys[index].children[0].id;
            }
        }
        this.emitData();
    },
    choseArea(e){
      this.area = e;
      this.emitData();
    },
    emitData(){
      this.$emit('getRegionData',this.country,this.province,this.city,this.area,[regions.data[this.country],regions.data[this.province],regions.data[this.city],regions.data[this.area]]);
    },
    resetData(){
      this.country = '';
      this.province = '';
      this.city = '';
      this.area = '';
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-input {
  width: 100% !important;
}
/deep/ .region-selects {
  .el-select {
    width: 100px;
    margin-right: 10px;
  }
  .el-select:last-child {
    margin-right: 0px;
  }
  .el-input__inner {
    border-radius: 4px;
    height: 32px !important;
    line-height: 32px;
    padding-right: 30px;
    padding-left: 8px !important;
  }
  .el-icon-arrow-up:before {
    position: relative;
    top: 1px;
  }
  .el-select .el-input.is-disabled .el-input__inner {
    color: #c0c4cc;
  }
}
/deep/ .width270 .el-select {
  width: 270px;
}
/deep/ .width270 .el-select:first-child {
  margin-right: 20px;
}
/deep/ .height40 .el-input__inner {
  height: 40px !important;
  line-height: 30px;
}
</style>